import { render, staticRenderFns } from "./DocRessincronizacao.vue?vue&type=template&id=1a1e17a6&scoped=true"
import script from "./DocRessincronizacao.vue?vue&type=script&lang=js"
export * from "./DocRessincronizacao.vue?vue&type=script&lang=js"
import style0 from "./DocRessincronizacao.vue?vue&type=style&index=0&id=1a1e17a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1e17a6",
  null
  
)

export default component.exports